<template>
  <aside class="filters">
    <header class="filters-header">
      <h2 class="filters-title">{{t('Sort & Filters')}}</h2>
      <button @click="closeFiltersDialog">
        <span class="icon icon-close color-blue text-title-1"></span>
      </button>
    </header>

    <Sorting class="sorting-in-dialog"/>
    
    <UIAccordion
      :items="filterItems"
      :multiple="true"
      :default-open="['pricing', 'rating', 'categories']"
      class="filter-variant"
      item-key="id"
    >
      <template #header="{ item, isOpen }">
        <span class="filters-section__title">{{ typeof item === 'string' ? item : item.title }}</span>
        <span class="icon icon-chevron-down filters-section__icon" :class="{ 'is-open': isOpen }"></span>
      </template>

      <template #content-pricing>
        <Pricing @update="updatePriceFilter"/>
      </template>

      <template #content-rating>
        <Rating @update="updateRatingFilter"/>
      </template>

      <template #content-categories>
        <Categories @update="updateCategoriesFilter"/>
      </template>
    </UIAccordion>
  </aside>
</template>

<script lang="ts" setup>
import Rating from "@/components/MarketPage/Filters/Rating.vue";
import Pricing from "~/components/MarketPage/Filters/Pricing.vue";
import UIAccordion from "~/components/UIAccordion.vue";
import { useFilters } from "@/composables/useFilters";
import Sorting from "~/components/MarketPage/Sorting.vue";
import Categories from "~/components/MarketPage/Filters/Categories.vue";

const { updateCategoriesFilter, updatePriceFilter, updateRatingFilter } = useFilters();
const { t } = useI18n()
const emit = defineEmits(["close"]);

const filterItems = [
  { id: 'pricing', title: t('Pricing') },
  { id: 'rating', title: t('Rate') },
  { id: 'categories', title: t('Categories') }
]


function closeFiltersDialog() {
  emit("close");
}
</script>

<style lang="scss" scoped src="./filters-style.scss"></style>
